import { render, staticRenderFns } from "./StatusIconChibis.vue?vue&type=template&id=1fe2aed8&scoped=true&"
import script from "./StatusIconChibis.vue?vue&type=script&lang=js&"
export * from "./StatusIconChibis.vue?vue&type=script&lang=js&"
import style0 from "./StatusIconChibis.vue?vue&type=style&index=0&id=1fe2aed8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe2aed8",
  null
  
)

export default component.exports